import React from 'react'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'

import { isAuth, redirectToLogin } from 'utils/auth'

export const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={props => (isAuth() ? <Component {...props} /> : redirectToLogin())} />
)

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
}
